import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';
import type { QueriesType } from '../../components/telematics/types';

export const RangeMethodSchema = z.enum(['dataRange', 'selectedDay']);
export type RangeMethodType = z.infer<typeof RangeMethodSchema>;

export const StatusApiDefaultSettings = {
    reloadIntervalSeconds: 60,
    rangeMethod: 'selectedDay',
    query: {
        // $between: ['today:-14', 'today:+14'],
    },
    widgetName: 'JobStatus',
    mainQuery: {},
    selectedDay: null,
};

export const StatusApiDataRequestSchema = z.object({
    reloadIntervalSeconds: z.number().catch(StatusApiDefaultSettings.reloadIntervalSeconds),
    rangeMethod: RangeMethodSchema.catch(StatusApiDefaultSettings.rangeMethod),
    query: z.record(z.any()).catch(StatusApiDefaultSettings.query),
    widgetName: z.string().catch('JobStatus'),
    mainQuery: z.any().catch({}),
    selectedDay: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format')
        .nullable()
        .default(null),
});
export type StatusApiDataRequestType = z.infer<typeof StatusApiDataRequestSchema>;

export class WidgetOneApi {
    public static async getData<T>(
        api: Api,
        settings: StatusApiDataRequestType,
        S: z.Schema
    ): Promise<T> {
        return api.getData('post', '/widget/populate', settings, StatusApiDataRequestSchema, S);
    }

    public static async parseSettings(
        settings: StatusApiDataRequestType,
        widgetName: string,
        mainQuery: QueriesType
    ) {
        settings = {
            ...StatusApiDefaultSettings,
            ...settings,
            mainQuery,
            widgetName,
        };
        try {
            settings = StatusApiDataRequestSchema.parse(settings);
        } catch (e) {
            console.error('WidgetOne: Invalid settings', e);
        }
        return settings;
    }
}
